import { ImportedFromBadge } from "./ImportedFromBadge";
import { ProfileHeader } from "./ProfileHeader";
import { WorkExperienceSection } from "./WorkExperienceSection";
import { TagsSection } from "./TagsSection";

interface ProfileCardProps {
  userName: string;
  profilePictureUrl: string;
  currentRole?: string;
  currentCompany?: string;
  headline?: string;
  location?: string;
  education?: any[];
  summaryPreview?: string;
  experience: any[];
}

export function ProfileCard({
  userName,
  profilePictureUrl,
  currentRole,
  currentCompany,
  headline,
  location,
  education,
  summaryPreview,
  experience
}: ProfileCardProps) {
  return (
    <div 
      className="w-full bg-white rounded-[32px] shadow-lg mb-8 sm:mb-12 relative overflow-hidden"
      style={{
        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
      }}
    >
      <ImportedFromBadge />

      <div className="p-6 sm:p-8 md:p-10">
        <ProfileHeader
          userName={userName}
          profilePictureUrl={profilePictureUrl}
          currentRole={currentRole}
          currentCompany={currentCompany}
          headline={headline}
          location={location}
          education={education}
          summaryPreview={summaryPreview}
        />

        <WorkExperienceSection experience={experience} />

        <TagsSection currentRole={currentRole} />
      </div>
    </div>
  );
}

